import { useEffect } from 'react';
import useIsMounted from './useIsMounted';

/**
 * Hooks to add a listener when the window gets resized and dispatch and event controlled by a debounce time.
 * @param {Function} onResize The callback to execute after window resize and debounce time.
 * @param {number} [debounceTime=100] The time to control a minimum amount of time before execute the callback.
 */
function useResizeListener(onResize, debounceTime = 100) {
  const isMounted = useIsMounted();

  useEffect(() => {
    let timeoutId = null;

    const resizeHandler = () => {
      if (isMounted.current) {
        onResize();
      }
    };

    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(resizeHandler, debounceTime);
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [onResize, debounceTime]);
}

export default useResizeListener;
